import { EditorV3 } from "@azu-business/editor-v3";
import {} from "aic";
import { stylesToV3 } from "components/common/stylesToV3";
import { AppSettingsContext } from "contexts/AppSettingsContext";
import { TlfContext } from "contexts/TlfContext";
import { eStyleTlfType } from "functions/api/styles/getAllStyles";
import { TlfItemReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { isEqual } from "lodash";
import { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { UPDATE_TLF } from "../../contexts/tlf/interface";

/**
 * Editor for programmer notes attached to a TLF item.
 *
 * @returns A JSX element rendering the programmer notes editor or an empty fragment.
 */
export const ProgrammerNotes = (): React.ReactElement => {
  const appSettings = useContext(AppSettingsContext);
  const tlfContext = useContext(TlfContext);
  const tlfData: TlfItemReadDto | null =
    tlfContext && tlfContext.tlfData && "programmerNotes" in tlfContext.tlfData
      ? (tlfContext.tlfData as TlfItemReadDto)
      : null;

  return !tlfContext || !tlfData ? (
    <></>
  ) : (
    <Container>
      <Row>
        <Col>
          <h4>Programmer notes</h4>
          <div className="notes-box">
            <EditorV3
              id="programmernotes"
              allowNewLine
              customStyleMap={stylesToV3(appSettings.styles, eStyleTlfType.Template)}
              debounceMilliseconds={-1}
              editable={!tlfContext.readOnly}
              input={tlfData.programmerNotes}
              setObject={(ret) => {
                /* istanbul ignore else */
                if (!isEqual(ret, tlfData.programmerNotes)) {
                  tlfContext.dispatch!({
                    operation: UPDATE_TLF,
                    tlfData: {
                      programmerNotes:
                        ret ??
                        // istanbul ignore next
                        tlfData.programmerNotes,
                    },
                    calledFrom: "ProgrammerNotes:Update",
                  });
                }
              }}
              style={{
                ...appSettings.defaultTableStyle,
                minHeight: "120px",
                height: "120px",
                border: "none",
              }}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

ProgrammerNotes.displayName = "ProgrammerNotes";
